// extracted by mini-css-extract-plugin
export default {"body":"styles_body__uqbnf","content":"styles_content__cRgzL","headings":"styles_headings__JNSC7","tokens":"styles_tokens__nZ+T9","token":"styles_token__l+z2e"};